import { Injectable } from '@angular/core';
import {BaseService} from "../../services/base.service";
import { HttpClient, HttpResponse } from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import { Observable, retry, catchError } from "rxjs";
import {HelperService} from "../../helper.service";
import {OrderStatusModel} from "../models-otc/order-status-model";
import {RepresentativeModel} from "../models-otc/representative-model";

@Injectable({
    providedIn: 'root'
})
export class OrderManagerService extends BaseService {

    constructor(
        private httpClient: HttpClient,
        public snackBar: MatSnackBar,
        public helper: HelperService,
    ) {
        super();
    }

    adminDashUrl = this.API_ADMIN_BASE_URL + 'v1/back-office/';

    getOrderStatusList(): Observable<OrderStatusModel[]> {
        return this.httpClient.get<OrderStatusModel[]>(this.OTC_BASE_URL + `status?date=`)
            .pipe(
                retry(1),
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving Order Status List','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }


    getRepresentativeList(userId:number): Observable<RepresentativeModel[]> {
        return this.httpClient.get<RepresentativeModel[]>(this.OTC_BASE_URL + `representative/${userId}`)
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving Representative List','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

    downloadOrderReport(reportForm, userId: number):  Observable<HttpResponse<Blob>> {
        return this.httpClient.post<Blob>(this.adminDashUrl + `otc/report/orderAgent/${userId}`, reportForm, {
            observe: 'response',
            responseType: 'blob' as 'json'
        });
    }
}


